import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Guarda los rangos de fechas seleccionados por cuenta para mantener filtros entre sesiones.
 * Estructura: { [accountId]: { fromDate: string, toDate: string } }
 */
const useBankMovementsFiltersStore = create(
  persist(
    (set, get) => ({
      filtersByAccount: {},
      hydrated: false,

      setDateRange: (accountId, fromDate, toDate) => {
        if (!accountId) return;
        set((state) => ({
          filtersByAccount: {
            ...state.filtersByAccount,
            [accountId]: { fromDate, toDate },
          },
        }));
      },

      getDateRange: (accountId) => {
        if (!accountId) return null;
        return get().filtersByAccount[accountId] || null;
      },

      clearAccountFilters: (accountId) => {
        if (!accountId) return;
        set((state) => {
          const next = { ...state.filtersByAccount };
          delete next[accountId];
          return { filtersByAccount: next };
        });
      },

      setHydrated: (value) => {
        set({ hydrated: value });
      },
    }),
    {
      name: 'persist:bank-movements-filters',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      // Usamos storage por defecto (localStorage) igual que otros stores (page-visits, etc.)
      onRehydrateStorage: () => (state) => {
        state?.setHydrated?.(true);
      },
    }
  )
);

export default useBankMovementsFiltersStore;
